import { createBrowserRouter, Navigate } from "react-router";
import { Dashboard } from "./pages/Dashboard";
import { Vehicles } from "./pages/Vehicles";
import { Reports } from "./pages/Reports";
import { CapacityPlanning } from "./pages/CapacityPlanning";
import { Documents } from "./pages/Documents";
import { CostAnalysis } from "./pages/CostAnalysis";
import { Settings } from "./pages/Settings";
import { SupplyManagement } from "./pages/SupplyManagement";
import { Tracking } from "./pages/Tracking";
import { FlexibleTracking } from "./pages/FlexibleTracking";
import { TrackingListPage } from "./pages/TrackingListPage";
import { DecisionMatrix } from "./pages/DecisionMatrix";
import { LiveTracking } from "./pages/LiveTracking";
import { WarehouseTransfer } from "./pages/WarehouseTransfer";
import { OfferPortal } from "./pages/OfferPortal";
import { Drivers } from "./pages/Drivers";
import { PersonnelFiles } from "./pages/PersonnelFiles";
import { GateEntryExit } from "./pages/GateEntryExit";
import { VehicleDocuments } from "./pages/VehicleDocuments";
import { DriverApplications } from "./pages/DriverApplications";
import { DriverLeaveRequests } from "./pages/DriverLeaveRequests";
import { DriverViolations } from "./pages/DriverViolations";
import { DriverIncidentReports } from "./pages/DriverIncidentReports";
import { TrafficFines } from "./pages/TrafficFines";
import { CustomerManagement } from "./pages/CustomerManagement";
import { VehicleManagement } from "./pages/VehicleManagement";
import { WeighbridgePoints } from "./pages/WeighbridgePoints";
import { FuelExceptionPoints } from "./pages/FuelExceptionPoints";
import { VehicleInspectionForms } from "./pages/VehicleInspectionForms";
import { VehicleAssignmentForms } from "./pages/VehicleAssignmentForms";
import { TrailerManagement } from "./pages/TrailerManagement";
import { Login } from "./pages/Login";
import { PublicDriverApplication } from "./pages/PublicDriverApplication";
import { DriverMobileAuth } from "./pages/DriverMobileAuth";
import { DriverMobileRegister } from "./pages/DriverMobileRegister";
import { DriverMobileDashboard } from "./pages/DriverMobileDashboard";
import { DriverMobileHome } from "./pages/DriverMobileHome";
import { DriverMobileDefenses } from "./pages/DriverMobileDefenses";
import { DriverMobileProfile } from "./pages/DriverMobileProfile";
import { DriverMobileNotifications } from "./pages/DriverMobileNotifications";
import { DriverMobileOfferDetail } from "./pages/DriverMobileOfferDetail";
import { DriverMobileEarnings } from "./pages/DriverMobileEarnings";
import { DriverMobilePayrolls } from "./pages/DriverMobilePayrolls";
import { DriverMobileHistory } from "./pages/DriverMobileHistory";
import { DriverMobileDocuments } from "./pages/DriverMobileDocuments";
import { DriverMobileCorporateVehicles } from "./pages/DriverMobileCorporateVehicles";
import { DriverMobileCorporateDrivers } from "./pages/DriverMobileCorporateDrivers";
import { DriverMobileNotificationsSettings } from "./pages/DriverMobileNotificationsSettings";
import { DriverMobileSecurity } from "./pages/DriverMobileSecurity";
import { DriverMobileShipmentTracking } from "./pages/DriverMobileShipmentTracking";
import { DriverMobileAssignments } from "./pages/DriverMobileAssignments";
import { DriverMobileSupportCenter } from "./pages/DriverMobileSupportCenter";
import { DriverMobileEmptyReturn } from "./pages/DriverMobileEmptyReturn";
import { DriverSupportContact } from "./pages/DriverSupportContact";
import { BackupManagement } from "./pages/BackupManagement";
import { WarehouseSettings } from "./pages/WarehouseSettings";
import { ContractManagement } from "./pages/ContractManagement";
import { RampManagement } from "./pages/RampManagement";
import { ShiftManagement } from "./pages/ShiftManagement";
import { ShiftAssignments } from "./pages/ShiftAssignments";
import { ExpenseSubmission } from "./pages/ExpenseSubmission";
import { ExpenseApproval } from "./pages/ExpenseApproval";
import { ExpenseCategories } from "./pages/ExpenseCategories";
import { ShareTargets } from "./pages/ShareTargets";
import { BasePrices } from "./pages/BasePrices";
import { PaymentOrders } from "./pages/PaymentOrders";
import { AccountingWorkflow } from "./pages/AccountingWorkflow";
import { VehicleAssignments } from "./pages/VehicleAssignments";
import { OfferRequests } from "./pages/OfferRequests";
import { Automations } from "./pages/Automations";
import { DriverTracking } from "./pages/DriverTracking";
import { ShipmentMonitoring } from "./pages/ShipmentMonitoring";
import { GeneralList2 } from "./pages/GeneralList2";
import { GeneralList2Spot } from "./pages/GeneralList2Spot";
import { ShipmentTimelinePanel } from "./pages/ShipmentTimelinePanel";

import { WarehouseRampAssignment } from "./pages/WarehouseRampAssignment";
import { BidMarketplace } from "./pages/BidMarketplace";
import { MyBids } from "./pages/MyBids";
import { ActiveJobs } from "./pages/ActiveJobs";
import { Profile } from "./pages/Profile";
import { RoleManagement } from "./pages/RoleManagement";
import { UserManagement } from "./pages/UserManagement";
import { ApprovedDrivers } from "./pages/ApprovedDrivers";
import { SystemLogs } from "./pages/SystemLogs";
import { ApiKeyManagement } from "./pages/ApiKeyManagement";
import { SupportCenter } from "./pages/SupportCenter";
import { HelpDeskGuide } from "./pages/HelpDeskGuide";
import { HelpDeskGuidePrint } from "./pages/HelpDeskGuidePrint";
import { About } from "./pages/About";
import { Privacy } from "./pages/Privacy";
import { Disclosure } from "./pages/Disclosure";
import { RegistrationAgreement } from "./pages/RegistrationAgreement";
import { ExplicitConsent, ElectronicConsent } from "./pages/ConsentPage";
import { PushNotificationsAdmin } from "./pages/PushNotificationsAdmin";
import { SupplyMetadataManagement } from "./pages/SupplyMetadataManagement";
import { WhatsappSend } from "./pages/WhatsappSend";
import { WhatsappWebPanel } from "./pages/WhatsappWebPanel";
import { BulkSmsPage } from "./pages/BulkSmsPage";
import TestStokbar from "./pages/TestStokbar";
import { WaitingRecords } from "./pages/WaitingRecords";
import { Beklemeler } from "./pages/Beklemeler";
import { BeklemeBedeliRaporu } from "./pages/BeklemeBedeliRaporu";
import { YatmaRaporu } from "./pages/YatmaRaporu";
import { ArrivalTracking } from "./pages/ArrivalTracking";
import { PointVisitLogs } from "./pages/PointVisitLogs";
import { DriverPayrolls } from "./pages/DriverPayrolls";
import { VersionHistory } from "./pages/VersionHistory";
import { FlexibleReportsPage } from "./pages/FlexibleReportsPage";
import { SeyirDriverComparison } from "./pages/SeyirDriverComparison";
import { ReturnLoadPotentialReport } from "./pages/ReturnLoadPotentialReport";
import { Notifications } from "./pages/Notifications";
import CorporateTracking from "./pages/CorporateTracking";
import { CorporateCarrierDashboard } from "./pages/CorporateCarrierDashboard";
import { CorporateDrivers } from "./pages/CorporateDrivers";
import { CorporateProfile } from "./pages/CorporateProfile";
import { SpotDriverLocationLogs } from "./pages/SpotDriverLocationLogs";
import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { usePermissions } from './hooks/usePermissions';
import { useAuth } from './contexts/AuthContext';
import { hasUserRole } from './utils/userRoles';
import { ROUTE_PERMISSIONS } from './config/permissions';

function HomeIndexRedirect() {
  const { canAccessPage } = usePermissions();
  const { user } = useAuth();

  if (hasUserRole(user, 'corporate-external-transport') && !(user as any)?.externalTransportAccountUserId && !(user as any)?.external_transport_account_user_id) {
    return <CorporateCarrierDashboard />;
  }

  const fallbackPaths = [
    '/tracking-list',
    '/fleet-status-list',
    '/spot-status-list',
    '/accounting-workflow',
    '/live-tracking',
    '/supply',
    '/customer-management',
    '/vehicle-management',
    '/drivers',
    '/personnel-files',
    '/beklemeler',
    '/reports',
    '/support-center',
    '/settings',
  ];

  if (canAccessPage('/')) {
    return <Dashboard />;
  }

  const firstAccessiblePath = fallbackPaths.find((path) => canAccessPage(path))
    || Object.keys(ROUTE_PERMISSIONS)
      .filter((path) => !path.includes('?'))
      .find((path) => canAccessPage(path));
  if (firstAccessiblePath) {
    return <Navigate to={firstAccessiblePath} replace />;
  }

  return <div className="p-6 text-sm text-slate-600">Bu kullanici icin erisilebilir menu bulunamadi.</div>;
}

export const router = createBrowserRouter([
  {
    path: "/login",
    Component: Login,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-application",
    Component: PublicDriverApplication,
    errorElement: <ErrorBoundary />,
  },
  // Driver Mobile Routes
  {
    path: "/driver-mobile-auth",
    Component: DriverMobileAuth,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/contact",
    Component: DriverSupportContact,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-register",
    Component: DriverMobileRegister,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-home",
    Component: DriverMobileHome,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-defenses",
    Component: DriverMobileDefenses,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-dashboard",
    Component: DriverMobileDashboard,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-profile",
    Component: DriverMobileProfile,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-notifications",
    Component: DriverMobileNotifications,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-earnings",
    Component: DriverMobileEarnings,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-payrolls",
    Component: DriverMobilePayrolls,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-history",
    Component: DriverMobileHistory,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-documents",
    Component: DriverMobileDocuments,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-corporate-vehicles",
    Component: DriverMobileCorporateVehicles,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-corporate-drivers",
    Component: DriverMobileCorporateDrivers,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-vehicle-documents",
    Component: VehicleDocuments,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-offer/:id",
    Component: DriverMobileOfferDetail,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-notifications-settings",
    Component: DriverMobileNotificationsSettings,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-security",
    Component: DriverMobileSecurity,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-shipment-tracking/:shipmentId",
    Component: DriverMobileShipmentTracking,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-assignments",
    Component: DriverMobileAssignments,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-support",
    Component: DriverMobileSupportCenter,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/driver-mobile-empty-return",
    Component: DriverMobileEmptyReturn,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/about",
    Component: About,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/privacy",
    Component: Privacy,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/disclosure",
    Component: Disclosure,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/registration-agreement",
    Component: RegistrationAgreement,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/explicit-consent",
    Component: ExplicitConsent,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/electronic-consent",
    Component: ElectronicConsent,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [
      { index: true, Component: HomeIndexRedirect },
      { path: "live-tracking", Component: LiveTracking },
      { path: "supply", Component: SupplyManagement },
      { path: "tracking", Component: Tracking },
      { path: "tracking-list", Component: TrackingListPage },
      { path: "decision-matrix", Component: DecisionMatrix },
      { path: "shipment-timeline", Component: ShipmentTimelinePanel },
      { path: "fleet-status-list", Component: GeneralList2 },
      { path: "spot-status-list", Component: GeneralList2Spot },

      { path: "automations", Component: Automations },
      { path: "warehouse-transfer", Component: WarehouseTransfer },
      { path: "offer-portal", Component: OfferPortal },
      { path: "customer-management", Component: CustomerManagement },
      { path: "vehicle-management", Component: VehicleManagement },
      { path: "weighbridge-points", Component: WeighbridgePoints },
      { path: "fuel-exception-points", Component: FuelExceptionPoints },
      { path: "vehicle-inspection-forms", Component: VehicleInspectionForms },
      { path: "vehicle-assignment-forms", Component: VehicleAssignmentForms },
      { path: "trailer-management", Component: TrailerManagement },
      { path: "drivers", Component: Drivers },
      { path: "driver-violations", Component: DriverViolations },
      { path: "personnel-files", Component: PersonnelFiles },
      { path: "gate-entry-exit", Component: GateEntryExit },
      { path: "vehicle-documents", Component: VehicleDocuments },
      { path: "driver-applications", Component: DriverApplications },
      { path: "driver-leave-requests", Component: DriverLeaveRequests },
      { path: "driver-payrolls", Component: DriverPayrolls },
      { path: "driver-incident-reports", Component: DriverIncidentReports },
      { path: "traffic-fines", Component: TrafficFines },
      { path: "shift-assignments", Component: ShiftAssignments },
      { path: "vehicles", Component: Vehicles },
      { path: "reports", Component: Reports },
      { path: "return-load-potential-report", Component: ReturnLoadPotentialReport },
      { path: "flexible-reports", Component: FlexibleReportsPage },
      { path: "reports-menu", element: <Navigate to="/reports" replace /> },
      { path: "capacity", Component: CapacityPlanning },
      { path: "documents", Component: Documents },
      { path: "cost-analysis", Component: CostAnalysis },
      { path: "warehouse-settings", Component: WarehouseSettings },
      { path: "contract-management", Component: ContractManagement },
      { path: "ramp-management", Component: RampManagement },
      { path: "shift-management", Component: ShiftManagement },
      { path: "seyir-driver-comparison", Component: SeyirDriverComparison },
      { path: "settings", Component: Settings },
      { path: "expense-submission", Component: ExpenseSubmission },
      { path: "expense-approval", Component: ExpenseApproval },
      { path: "expense-categories", Component: ExpenseCategories },
      { path: "share-targets", Component: ShareTargets },
      { path: "push-notifications", Component: PushNotificationsAdmin },
      { path: "base-prices", Component: BasePrices },
      { path: "accounting-workflow", Component: AccountingWorkflow },
      { path: "payment-orders", Component: PaymentOrders },
      { path: "vehicle-assignments", Component: VehicleAssignments },
      { path: "offer-requests", Component: OfferRequests },
      { path: "driver-tracking", Component: DriverTracking },
      { path: "shipment-monitoring", Component: ShipmentMonitoring },
      { path: "warehouse-ramp-assignment", Component: WarehouseRampAssignment },
      { path: "waiting-records", Component: WaitingRecords },
      { path: "beklemeler", Component: Beklemeler },
      { path: "bekleme-bedeli-raporu", Component: BeklemeBedeliRaporu },
      { path: "yatma-raporu", Component: YatmaRaporu },
      { path: "arrival-tracking", Component: ArrivalTracking },
      { path: "point-visit-logs", Component: PointVisitLogs },
      { path: "spot-driver-location-logs", Component: SpotDriverLocationLogs },
      { path: "bid-marketplace", Component: BidMarketplace },
      { path: "my-bids", Component: MyBids },
      { path: "active-jobs", Component: ActiveJobs },
      { path: "corporate-drivers", Component: CorporateDrivers },
      { path: "corporate-profile", Component: CorporateProfile },
      { path: "profile", Component: Profile },
      { path: "role-management", Component: RoleManagement },
      { path: "user-management", Component: UserManagement },
      { path: "approved-drivers", Component: ApprovedDrivers },
      { path: "corporate-tracking-list", Component: CorporateTracking },
      { path: "system-logs", Component: SystemLogs },
      { path: "api-key-management", Component: ApiKeyManagement },
      { path: "version-history", Component: VersionHistory },
      { path: "backup-management", Component: BackupManagement },
      { path: "whatsapp-send", Component: WhatsappSend },
      { path: "bulk-sms", Component: BulkSmsPage },
      { path: "whatsapp-web", Component: WhatsappWebPanel },
      { path: "support-center", Component: SupportCenter },
      { path: "help-desk-guide", Component: HelpDeskGuide },
      { path: "help-desk-guide-export", Component: HelpDeskGuidePrint },
      { path: "supply-metadata", Component: SupplyMetadataManagement },
      { path: "test-stokbar", Component: TestStokbar },
      { path: "notifications", Component: Notifications },
    ],
  },
]);
